import { render, staticRenderFns } from "./RequestPasswordResetForm.vue?vue&type=template&id=598261aa&scoped=true&"
import script from "./RequestPasswordResetForm.vue?vue&type=script&lang=js&"
export * from "./RequestPasswordResetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598261aa",
  null
  
)

export default component.exports